export default Object.freeze({
    DEFAULT: 'DEFAULT',
    REMOVABLE: 'REMOVABLE',
    ADD: 'ADD',
    LABEL: 'LABEL',
});
